<div class="m-2" [formGroup]="form">
  <div class="p-8 bg-slate-50 rounded-xl border border-slate-200 w-full">
    <app-element-type-settings
      [elementId]="elementId()"
      [elementType]="form.value.type"
    ></app-element-type-settings>
  </div>
</div>
